<template>
  <div
      class="product-card__prices"
      :class="{
        'with-bonus': !!fixedBonus,
      }"
      data-eq-part="product-card__prices"
  >
    <div>
      <div>{{ product.getPriceFormatted('monthly') }}&thinsp;€</div>
      <div>pro Monat</div>
    </div>
    <div v-if="fixedBonus">
      <div>{{ fixedBonus.valueGrossFormatted }}&thinsp;€</div>
      <div>{{ fixedBonus.label }}
        <IoTooltip v-if="fixedBonus.description" class="d-print-none">
          <template v-slot:title>
            <div v-html="fixedBonus.description" />
          </template>
          <FontAwesomeIcon :icon="faInfoCircle" />
        </IoTooltip>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Product from '@/classes/Product';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

library.add(faInfoCircle);

const props = defineProps<{
  product: Product
}>();

const fixedBonus = props.product.getSummedBonus('fixed');
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.product-card__prices {
  --prices-grid-gap: 20px;
  padding: 20px 0;
  background-color: #ECF2F6;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  justify-content: space-between;
  text-align: center;

  &.with-bonus {
    grid-template-columns: 1fr auto 2fr auto 1fr;
  }

  @media(min-width: map-get($grid-breakpoints, 'lg')) {
    padding: 30px 0;
  }

  > div {
    padding: 0 20px;

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
      padding: 0 40px;
    }

    &:first-child {
      grid-row: 1 / 2;
      grid-column: 2 / 3;
    }

    &:last-child:not(:first-child) {
      grid-row: 1 / 2;
      grid-column: 4 / 5;
    }

    > div {
      &:first-child {
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.5;

        @media(min-width: map-get($grid-breakpoints, 'lg')) {
          font-size: 1.875rem;
          white-space: nowrap;
        }
      }

      &:nth-child(2) {
        font-size: .75rem;

        @media(min-width: map-get($grid-breakpoints, 'lg')) {
          font-size: 1.125rem;
        }
      }
    }
  }
}
</style>
